import styled from 'styled-components';
import { Container as DefaultContainer } from '../Profile/ProfileNavigation.styles';

export const Container = styled(DefaultContainer)`
  margin: 29px 0;
`;
